<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
  .map-container{
    height: 780px;
  }

  .values-container{
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="lg:w-1/3 sm:w-1/2 w-full">
                <div class="w-full grid-view-item h-full">
                    <vx-card class="grid-view-item mb-base overflow-hidden h-full" v-if="response">
                        <gridPrincipalItem
                          img="energy"
                          :name="response.alias"
                          :description="$t('Labels.Alias')"
                          :name2="response.serie"
                          :description2="$t('Labels.Serie')"
                        ></gridPrincipalItem>
                        <div class="absolute right-0 top-0">
                            <vs-button  @click="deviceStatistics()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="bar_chart" type="border">
                            </vs-button>
                            <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="goToConfig()" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-settings" icon-pack="feather" type="border">
                            </vs-button>
                        </div>
                        <vs-divider/>
                        <div class="values-container">
                        <valueItem
                          :description="$tc('Labels.Energy')"
                          img="energy"
                          :value="parseFloat(response.energia || 0).toFixed(2)"
                          unit="Wh" :min="response.min_energy"
                          :max="response.max_energy">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.Energy', 2, { n: 'A' })"
                          img="energy"
                          :value="parseFloat(response.energia_a || 0).toFixed(2)"
                          unit="Wh" :min="response.min_energia_a"
                          :max="response.max_energia_a">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.Energy', 2, { n: 'B' })"
                          img="energy"
                          :value="parseFloat(response.energia_b || 0).toFixed(2)"
                          unit="Wh" :min="response.min_energia_b"
                          :max="response.max_energia_b">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.Energy', 2, { n: 'C' })"
                          img="energy"
                          :value="parseFloat(response.energia_c || 0).toFixed(2)"
                          unit="Wh" :min="response.min_energia_c"
                          :max="response.max_energia_c">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.ElectricCurrent', 2, { n: 'A' })"
                          img="corriente_a"
                          :value="parseFloat(response.corriente_a || 0).toFixed(2)"
                          unit="A" :min="response.min_corriente_a"
                          :max="response.max_corriente_a">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.ElectricCurrent', 2, { n: 'B' })"
                          img="corriente_b"
                          :value="parseFloat(response.corriente_b || 0).toFixed(2)"
                          unit="A" :min="response.min_corriente_b"
                          :max="response.max_corriente_b">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.ElectricCurrent', 2, { n: 'C' })"
                          img="corriente_c"
                          :value="parseFloat(response.corriente_c || 0).toFixed(2)"
                          unit="A" :min="response.min_corriente_c"
                          :max="response.max_corriente_c">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.Voltage', 2, { n: 'A' })"
                          img="voltaje_a"
                          :value="parseFloat(response.voltaje_a || 0).toFixed(2)"
                          unit="V" :min="response.min_voltaje_a"
                          :max="response.max_voltaje_a">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.Voltage', 2, { n: 'B' }) "
                          img="voltaje_b"
                          :value="parseFloat(response.voltaje_b || 0).toFixed(2)"
                          unit="V" :min="response.min_voltaje_b"
                          :max="response.max_voltaje_b">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.Voltage', 2, { n: 'C' })"
                          img="voltaje_c"
                          :value="parseFloat(response.voltaje_c || 0).toFixed(2)"
                          unit="V" :min="response.min_voltaje_c"
                          :max="response.max_voltaje_c">
                        </valueItem>
                        <valueItem
                          :description="$tc('Labels.Power', 2, { n: 'A' })"
                          img="potencia_a"
                          :value="parseFloat(response.potencia_a || 0).toFixed(2)"
                          unit="W"
                          :min="response.min_potencia_a"
                          :max="response.max_potencia_a"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.Power', 2, { n: 'B' })"
                          img="potencia_b"
                          :value="parseFloat(response.potencia_b || 0).toFixed(2)"
                          unit="W"
                          :min="response.min_potencia_b"
                          :max="response.max_potencia_b"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.Power', 2, { n: 'C' })"
                          img="potencia_c"
                          :value="parseFloat(response.potencia_c || 0).toFixed(2)"
                          unit="W"
                          :min="response.min_potencia_c"
                          :max="response.max_potencia_c"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.ReactivePower', 2, { n: 'A' })"
                          img="potencia_r_a"
                          :value="parseFloat(response.potencia_r_a || 0).toFixed(2)"
                          unit="VAR"
                          :min="response.min_potencia_r_a"
                          :max="response.max_potencia_r_a"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.ReactivePower', 2, { n: 'B' })"
                          img="potencia_r_b"
                          :value="parseFloat(response.potencia_r_b || 0).toFixed(2)"
                          unit="VAR"
                          :min="response.min_potencia_r_b"
                          :max="response.max_potencia_r_b"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.ReactivePower', 2, { n: 'C' })"
                          img="potencia_r_c"
                          :value="parseFloat(response.potencia_r_c || 0).toFixed(2)"
                          unit="VAR"
                          :min="response.min_potencia_r_c"
                          :max="response.max_potencia_r_c"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.Factor', 2, { n: 'A' })"
                          img="factor_a"
                          :value="parseFloat(response.factor_a || 0).toFixed(2)"
                          :min="response.min_factor_a"
                          :max="response.max_factor_a"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.Factor', 2, { n: 'B' })"
                          img="factor_b"
                          :value="parseFloat(response.factor_b || 0).toFixed(2)"
                          :min="response.min_factor_b"
                          :max="response.max_factor_b"
                        ></valueItem>
                        <valueItem
                          :description="$tc('Labels.Factor', 2, { n: 'C' })"
                          img="factor_c"
                          :value="parseFloat(response.factor_c || 0).toFixed(2)"
                          :min="response.min_factor_c"
                          :max="response.max_factor_c"
                        ></valueItem>
                        <valueItem :description="$t('Labels.Date')" img="fecha" :value="response.updated_at"></valueItem>
                        </div>
                    </vx-card>
                </div>

            </div>
            <div class="vx-col lg:w-2/3 sm:w-2/3 w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden address-card h-full">
                    <div class="avatar-info-container">
                        <span class="account-number">
                           {{$t("Labels.DeviceLocation")}}
                        </span>
                        <feather-icon
                            icon="EditIcon"
                            @click="editMap = true"
                            class="float-right cursor-pointer"
                            svgClasses="hover:text-primary"
                            v-if="!editMap && $store.state.AppActiveUser.userRole === 'MA'"/>
                        <feather-icon
                          icon="SaveIcon"
                          @click="saveMap()"
                          class="float-right cursor-pointer"
                          svgClasses="hover:text-primary"
                          v-if="editMap"/>
                        <div class="map-container basic-example" v-if="status_mapa">
                            <l-map :center="center" :zoom="zoom" v-if="response">
                                <l-tile-layer :attribution="attribution" :url="url">
                                </l-tile-layer>
                                <l-marker  :draggable="editMap" :lat-lng="marker" ref="position_marker">
                                    <l-icon :icon-anchor="staticAnchor">
                                        <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                    </l-icon>
                                </l-marker>
                            </l-map>
                        </div>
                        <div class="mt-2">
                          <label>{{$t('Labels.References')}}:</label>{{response.location_string  }}
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <div class="text-center text-3xl">{{$t("Labels.Alerts")}}</div>
                    <vs-divider/>
                    <div class="container-alerts" v-if="response.energia">
                        <minMaxItem
                          :title="$tc('Labels.ElectricCurrent', 2, { n: 'A' })"
                          :min="response.min_corriente_a"
                          :max="response.max_corriente_a"
                          unit="A"
                          img="corriente_a"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_corriente_a"
                          paramMax="max_corriente_a"
                          type="PUT"
                          :limitMin="limits.corriente.min || 0"
                          :limitMax="limits.corriente.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Voltage', 2, { n: 'A' })"
                          :min="response.min_voltaje_a"
                          :max="response.max_voltaje_a"
                          unit="V"
                          img="voltaje_a"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_voltaje_a"
                          paramMax="max_voltaje_a"
                          type="PUT"
                          :limitMin="limits.voltaje.min || 0"
                          :limitMax="limits.voltaje.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Power', 2, { n: 'A' })"
                          :min="response.min_potencia_a"
                          :max="response.max_potencia_a"
                          unit="W"
                          img="potencia_a"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_potencia_a"
                          paramMax="max_potencia_a"
                          type="PUT"
                          :limitMin="limits.potencia.min || 0"
                          :limitMax="limits.potencia.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.ReactivePower', 2, { n: 'A' })"
                          :min="response.min_potencia_r_a"
                          :max="response.max_potencia_r_a"
                          unit="VAR"
                          img="potencia_r_a"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_potencia_r_a"
                          paramMax="max_potencia_r_a"
                          type="PUT"
                          :limitMin="limits.potencia_r.min || 0"
                          :limitMax="limits.potencia_r.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Factor', 2, { n: 'A' })"
                          :min="response.min_factor_a"
                          :max="response.max_factor_a"
                          img="factor_a"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_factor_a"
                          paramMax="max_factor_a"
                          type="PUT"
                          :limitMin="limits.factor.min || 0"
                          :limitMax="limits.factor.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.ElectricCurrent', 2, { n: 'B' })"
                          :min="response.min_corriente_b"
                          :max="response.max_corriente_b"
                          unit="A"
                          img="corriente_b"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_corriente_b"
                          paramMax="max_corriente_b"
                          type="PUT"
                          :limitMin="limits.corriente.min || 0"
                          :limitMax="limits.corriente.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Voltage', 2, { n: 'B' })"
                          :min="response.min_voltaje_b"
                          :max="response.max_voltaje_b"
                          unit="V"
                          img="voltaje_b"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_voltaje_b"
                          paramMax="max_voltaje_b"
                          type="PUT"
                          :limitMin="limits.voltaje.min || 0"
                          :limitMax="limits.voltaje.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Power', 2, { n: 'B' })"
                          :min="response.min_potencia_b"
                          :max="response.max_potencia_b"
                          unit="W"
                          img="potencia_b"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_potencia_b"
                          paramMax="max_potencia_b"
                          type="PUT"
                          :limitMin="limits.potencia.min || 0"
                          :limitMax="limits.potencia.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.ReactivePower', 2, { n: 'B' })"
                          :min="response.min_potencia_r_b"
                          :max="response.max_potencia_r_b"
                          unit="VAR"
                          img="potencia_r_b"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_potencia_r_b"
                          paramMax="max_potencia_r_b"
                          type="PUT"
                          :limitMin="limits.potencia_r.min || 0"
                          :limitMax="limits.potencia_r.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Factor', 2, { n: 'B' })"
                          :min="response.min_factor_b"
                          :max="response.max_factor_b"
                          img="factor_b"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_factor_b"
                          paramMax="max_factor_b"
                          type="PUT"
                          :limitMin="limits.factor.min || 0"
                          :limitMax="limits.factor.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.ElectricCurrent', 2, { n: 'C' })"
                          :min="response.min_corriente_c"
                          :max="response.max_corriente_c"
                          unit="A"
                          img="corriente_c"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_corriente_c"
                          paramMax="max_corriente_c"
                          type="PUT"
                          :limitMin="limits.corriente.min || 0"
                          :limitMax="limits.corriente.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Voltage', 2, { n: 'C' })"
                          :min="response.min_voltaje_c"
                          :max="response.max_voltaje_c"
                          unit="V"
                          img="voltaje_c"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_voltaje_c"
                          paramMax="max_voltaje_c"
                          type="PUT"
                          :limitMin="limits.voltaje.min || 0"
                          :limitMax="limits.voltaje.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Power', 2, { n: 'C' })"
                          :min="response.min_potencia_c"
                          :max="response.max_potencia_c"
                          unit="W"
                          img="potencia_c"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_potencia_c"
                          paramMax="max_potencia_c"
                          type="PUT"
                          :limitMin="limits.potencia.min || 0"
                          :limitMax="limits.potencia.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.ReactivePower', 2, { n: 'C' })"
                          :min="response.min_potencia_r_c"
                          :max="response.max_potencia_r_c"
                          unit="VAR"
                          img="potencia_r_c"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_potencia_r_c"
                          paramMax="max_potencia_r_c"
                          type="PUT"
                          :limitMin="limits.potencia_r.min || 0"
                          :limitMax="limits.potencia_r.max || 0"
                        />
                        <minMaxItem
                          :title="$tc('Labels.Factor', 2, { n: 'C' })"
                          :min="response.min_factor_c"
                          :max="response.max_factor_c"
                          img="factor_b"
                          :url="`modelo/energies/${response.energies_id}`"
                          paramMin="min_factor_c"
                          paramMax="max_factor_c"
                          type="PUT"
                          :limitMin="limits.factor.min || 0"
                          :limitMax="limits.factor.max || 0"
                        />
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
/* global L:true */
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'
import { request } from '@/request.js'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    minMaxItem,
    valueItem,
    gridPrincipalItem
  },

  data () {
    return {
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      imagePath: 'images/vendor/leaflet/dist/',
      draggable: true,
      staticAnchor: [12, 27],
      response: [],
      icon_marker: [],
      status_mapa: false,
      uuid: this.$route.params.uuid,
      editMap: false,
      limits: {}
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `modelo/energies/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.limits = response.data.limits
        const [lat, lng] = this.response.location.split(',')
        this.marker = L.latLng(lat, lng)
        this.center = L.latLng(lat, lng)
        this.status_mapa = true
      })
    },
    async saveMap () {
      const location = this.$refs.position_marker.mapObject.getLatLng()
      const params = {
        url: `modelo/energies/${this.uuid}`,
        method: 'PUT',
        params: {
          location: `${location.lat},${location.lng}`
        }
      }
      await request(params).then(() => {
        this.editMap = false
      })
    },
    goToConfig () {
      window.location.href = `/energy/config/${this.uuid}`
    },

    deviceStatistics () {
      window.location.href = `/energy/statistics/${this.uuid}`
    }

  },
  sockets: {
    energie (payload) {
      if (this.uuid === payload.uuid) {
        this.response.corriente_a = payload.corriente_a
        this.response.corriente_b = payload.corriente_b
        this.response.corriente_c = payload.corriente_c
        this.response.energia = payload.energia
        this.response.energia_a = payload.energia_a
        this.response.energia_b = payload.energia_b
        this.response.energia_c = payload.energia_c
        this.response.factor_a = payload.factor_a
        this.response.factor_b = payload.factor_b
        this.response.factor_c = payload.factor_c
        this.response.potencia_a = payload.potencia_a
        this.response.potencia_b = payload.potencia_b
        this.response.potencia_c = payload.potencia_c
        this.response.potencia_r_a = payload.potencia_r_a
        this.response.potencia_r_b = payload.potencia_r_b
        this.response.potencia_r_c = payload.potencia_r_c
        this.response.voltaje_a = payload.voltaje_a
        this.response.voltaje_b = payload.voltaje_b
        this.response.voltaje_c = payload.voltaje_c
        this.response.status = payload.status
        this.response.updated_at = payload.updated_at
      }
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
<style scoped="">
    .vue2leaflet-map >>> .leaflet-shadow-pane {
  display: none !important;
}

>>> .vs-input--label {
  padding: 0;
}
</style>
